exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Input__Input--1VROp{\r\n\tmargin-bottom: 15px;\r\n}\r\n\r\n.Input__Input--1VROp label{\r\n\tmargin-bottom: 3px;\r\n\tpadding: 0;\r\n\tdisplay: block;\r\n\tfont-weight: bold;\r\n}\r\n\r\n.Input__Input--1VROp input{\r\n\tdisplay: block;\r\n\tbox-sizing: border-box;\r\n\tborder: 1px solid #bebebe;\r\n\tpadding: 7px;\r\n\tmargin: 0 0 5px;\r\n\twidth: 100%;\r\n\toutline: none;\r\n\ttransition: all 300ms ease-in-out;\r\n}\r\n\r\n.Input__Input--1VROp span{\r\n\tcolor:#f01f30;\r\n\tfont-size: 12px;\r\n\tfont-weight: bold;\r\n}\r\n\r\n.Input__Input--1VROp.Input__invalid--iI0zS label{\r\n\tcolor:#f01f30;\r\n}", ""]);

// exports
exports.locals = {
	"Input": "Input__Input--1VROp",
	"invalid": "Input__invalid--iI0zS"
};